import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IApplicationContext, IApplicationContextCustom } from '../../../shared/types/applicationContext';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    microfrontendsAPI: createMicrofrontendsAPI(),
  };
};
